import styled from 'styled-components'

export const ConversationOrderSummarySectionStyled = styled.section`
  overflow: hidden;
  background: ${(props) => props.theme.colors.white};
  border: 1px solid ${(props) => props.theme.colors.content.border};
  border-radius: ${(props) => props.theme.typography.pxToRem(8)};

  && .title .icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
